import { CreateElement } from 'vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { maxNumber } from '@/utils/baseFn'
import baseChart from './baseChart'
import { TableRowInfoList } from '@/types/tenant/dataPage'
import {
  MultiaxialCfg,
  G2BaseChartData,
  ChartOpt
} from '@/types/common/g2Charts'
import { cloneDeep } from 'lodash'
@Component
export default class Charts extends Vue {
  @Prop() chart!: TableRowInfoList;
  @Prop() slider!: boolean;
  render (h: CreateElement) {
    return h(this.handleChart().chartNode, {
      props: {
        ...this.handleChart().props,
        slider: this.slider || false
      }
    })
  }

  handleChart (): ChartOpt {
    const { chart } = this
    const {
      ratioValues,
      values,
      name = '',
      valueChartType,
      ratioChartType,
      valueName,
      valueUnit,
      ratioName,
      ratioUnit
    } = chart
    if ((!ratioValues || ratioValues === null) && values && values.length > 0) {
      return this.handleChartType(
        valueChartType,
        name,
        values,
        valueName,
        valueUnit
      )
      // return this.handleLine(chart, name)
    } else if (
      (!values || values === null) &&
      ratioValues &&
      ratioValues.length > 0
    ) {
      return this.handleChartType(
        ratioChartType,
        name,
        ratioValues,
        ratioName,
        ratioUnit
      )
    } else {
      // 双Y轴 柱状体+折线图 多轴图形
      return this.handleMultiaxialChart(chart, name)
    }
  }

  handleChartType (
    type: string | undefined,
    name: string,
    chartList: G2BaseChartData[],
    topNname = '',
    unit = ''
  ): ChartOpt {
    if (type === 'Line') {
      return this.handleLine(name, chartList, topNname, unit)
    } else {
      return this.handleBar(name, chartList, topNname, unit)
    }
  }

  handleLine (
    name: string,
    chartList: G2BaseChartData[],
    topNname: string,
    unit: string
  ) {
    return {
      chartNode: baseChart,
      props: {
        type: 'line',
        options: {
          axisShow: false,
          topName: `${topNname}(${unit})`,
          name,
          position: [[chartList[0].date, maxNumber(chartList, 'value')]]
        },
        values: chartList
      }
    }
  }

  handleBar (
    name: string,
    chartList: G2BaseChartData[],
    topNname: string,
    unit: string
  ) {
    return {
      chartNode: baseChart,
      props: {
        type: 'bar',
        axisShow: false,
        options: {
          topName: `${topNname}(${unit})`,
          name,
          position: [[chartList[0].date, maxNumber(chartList, 'value')]]
        },
        values: chartList
      }
    }
  }

  handleMultiaxialChart (chart: TableRowInfoList, name: string) {
    const {
      ratioValues,
      values,
      valueName,
      valueUnit,
      ratioName,
      ratioUnit,
      valueChartType,
      ratioChartType
    } = chart
    const _data: MultiaxialCfg[] = []
    const _ratioValues = cloneDeep(ratioValues)
    const _values = cloneDeep(values)
    const disparity = _values.length - _ratioValues.length
    for (let i = 0; i < disparity; i++) {
      _ratioValues.unshift({
        value: 0,
        date: _values[i].date
      })
    }

    _ratioValues.forEach((item: G2BaseChartData, i: number) => {
      _data.push({
        date: item.date,
        YLeft: item.value,
        YRight: _values[i].value
      })
    })
    return {
      chartNode: baseChart,
      props: {
        type: 'multiaxial',
        options: {
          axisShow: false,
          LChartType: ratioChartType,
          RChartType: valueChartType,
          topName: `${ratioName}(${ratioUnit})`,
          topName1: `${valueName}(${valueUnit})`,
          position: [
            [_data[0].date, maxNumber(_data, 'YLeft')],
            [_data[_data.length - 1].date, maxNumber(_data, 'YLeft')]
          ],
          name
        },
        values: _data
      }
    }
  }
}
